export enum PATH {
  LOGIN = '/login',
  TODOLISTS = '/todolists',
}
